import React from 'react';
import PropTypes from 'prop-types';
import AutoScopeStyles from '../../../../Common/Utilities/Decorators/AutoScopeStylesDecorator';
import RatesFiltersWithTabsView from "./TabbedComponent/RatesFiltersWithTabsView.jsx";
import RatesSearchActions from '../Actions/RatesSearchActions';
import applyDecoratorsDoNotUseInNewCode from '../../../../Common/Utilities/Decorators/ApplyDecorators';

class RatesFiltersView  extends React.Component {
    render() {
        return (
            <section>
                <RatesFiltersWithTabsView
                    options={ this.props.options }
                    searchCriteria={ this.props.searchCriteria }
                    onSearchCriteriaChange={this.onSearchCriteriaChange}
                    onOwnerFilterChange={this.onOwnerFilterChange} />
            </section>
        );
    }

    onSearchCriteriaChange = (newSelection) => {
        RatesSearchActions.searchCriteriaChanged(newSelection);
    }

    onOwnerFilterChange = (newOwnerId) => {
        RatesSearchActions.ownerSelectionChanged(newOwnerId)
    }

    static propTypes = {
        options: PropTypes.object.isRequired,
        searchCriteria: PropTypes.object.isRequired
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStyles);

export default withDecorators(RatesFiltersView);
